import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';
// material
import { Container, } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, InputAdornment, Button, } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Services from '../Service';
import { Autocomplete } from '@mui/material';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = "ADDSPECIALORDER"

export default function AddSpecialOrderAddEdit(props) {
  const [date, setDate] = useState(new Date());
  const [isFarmerClear, setIsFarmerClear] = useState(false);
  const [isUpdateData, setIsUpdateData] = useState(false);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [product, setProduct] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0',
    dateID: date.toISOString().split('T')[0],
    cropCategoryID: '0',
    cropID: '0',
    quantity: 0,
    price: 0
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Add",
    pageName: "Add Special Order"
  });

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center required'),
    dateID: Yup.date().required('Date required'),
    cropCategoryID: Yup.number().min(1, 'Please Select Crop Category').required('Crop Category required'),
    cropID: Yup.number().min(1, 'Please Select Crop').required('Crop required'),
    quantity: Yup.number().min(0.01, 'Quantity should be positive value').required('Quantity required'),
    price: Yup.number() .min(0.01, 'Price should be positive value')
    .test(
      'decimal-places',
      'Price can have maximum 2 decimal places',
      (value) => {
        if (!value) return true;
        return /^\d+(\.\d{1,2})?$/.test(value.toString());
      }
    )
    .test('max-price','Price cannot be greater than initial price ',
      function(value) {
        if (pageProps.isEdit && initialPrice > 0) {
          return value <= initialPrice;
        }
        return true; 
      }
    )
    .required('Price required')
});

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      dateID: formData.dateID,
      cropCategoryID: formData.cropCategoryID,
      cropID: formData.cropID,
      quantity: formData.quantity,
      price: formData.price
    },

    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  const { specialOrderID } = useParams();
  let decrypted = 0;
  const [initialPrice, setInitialPrice] = useState(0);

  useEffect(() => {
    decrypted = AESDecryptionParam(specialOrderID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        editingID: parseInt(decrypted),
        pageName: "Edit Special Order"
      })
    }
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    trackPromise(GetProductDetails());
    setIsFarmerClear(!isFarmerClear);
  }, [formik.values.operationEntityID])

  useEffect(() => {
    trackPromise(GetProductDetails());
    setIsFarmerClear(!isFarmerClear);
    if (pageProps.isEdit == false) {
      setValues({
        ...values,
        quantity: 0,
      });
    }
    formik.setTouched({
      ...formik.touched,
      quantity: false,
      price: false,
    });
  }, [formik.values.cropCategoryID]);

  useEffect(() => {
    if (pageProps.isEdit == false) {
      setValues({
        ...values,
        quantity: 0,
        price: 0,
      });

      formik.setTouched({
        ...formik.touched,
        quantity: false,
        price: false,
      });
    }
  }, [formik.values.cropID]);

  useEffect(() => {
    if (pageProps.editingID > 0) {
      trackPromise(setForEdit(pageProps.editingID))
    }
  }, [pageProps.editingID]);

  useEffect(() => {
    if (pageProps.isEdit == false) {
      if (formik.values.operationEntityID) {
        setValues({
          ...values,
          cropCategoryID: '0',
          cropID: '0',
          quantity: 0,
          price: 0,
        });

        formik.setTouched({
          ...formik.touched,
          cropCategoryID: false,
          cropID: false,
          quantity: false,
          price: false,
        });
      }
    }
    if (isUpdateData) {
      setValues({
        ...values,
        cropCategoryID: '0',
        cropID: '0'
      });
    }
  }, [formik.values.operationEntityID]);

  async function setForEdit(id) {
    var data = await Services.GetSpecialOrdersBySpecialOrderID(id);
    setInitialPrice(data.initialPrice);
    setValues({
      ...values,
      groupID: data.groupID,
      operationEntityID: data.operationEntityID,
      dateID: data.orderDate.split('T')[0],
      cropCategoryID: data.productCategoryID,
      cropID: data.cropID,
      quantity: data.quantity,
      price: data.realizedPrice
    })
  }

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITSPECIALORDER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
    })

    trackPromise(GetAllGroups());
    trackPromise(GetProductCategoties());
  }

  async function GetAllGroups() {
    var res = await Services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await Services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function GetProductCategoties() {
    var res = await Services.GetProductCategoties()
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetProductDetails() {
    var res = await Services.GetProductsByFactoryIDProductcatogeryID(formik.values.operationEntityID, formik.values.cropCategoryID)
    if (res != null) {
      setProduct(res);
    }
  }

  function handleSearchCrop(data, e) {
    if (data === undefined || data === null) {
      setValues({
        ...values,
        cropID: 0
      });
      return;
    } else {
      var valueV = data["productID"];

      setValues({
        ...values,
        cropID: valueV
      });
    }
  }

  function handleChangee(e) {
    const target = e.target;
    const value = target.value;
   
    setValues({
      ...values,
      [e.target.name]: value
    });
    if (e.target.name == 'operationEntityID') {
      setValues({
        ...values,
        operationEntityID : value,
        cropCategoryID: '0',
        cropID: '0',
      });
    }
    if (e.target.name == 'cropCategoryID') {
      setValues({
        ...values,
        cropCategoryID: value,
        cropID: '0',
      });
    }
  }
  

  async function SubmitForm(data) {
    if (pageProps.isEdit == false) {
      var factoryRes = operationEntityList.find(x => x.factoryID == data.operationEntityID)
      var cropRes = product.find(x => x.productID == data.cropID)
      let saveModel = {
        operationEntityID: data.operationEntityID,
        operationEntityCode: factoryRes.factoryCode,
        factoryName: factoryRes.factoryName,
        cropID: data.cropID,
        productCode: cropRes.productCode,
        productName: cropRes.productName,
        orderDate: data.dateID,
        quantity: parseFloat(data.quantity),
        realizedPrice: parseFloat(data.price),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.PlaceSpecialOrder(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/AddSpecialOrder');
        }, 800);
      } else {
        toast.error(res.message);
      }
    }
    else {
      var factoryRes = operationEntityList.find(x => x.factoryID == data.operationEntityID)
      var cropRes = product.find(x => x.productID == data.cropID)
      let saveModel = {
        specialOrderID: parseInt(pageProps.editingID),
        operationEntityID: data.operationEntityID,
        operationEntityCode: factoryRes.factoryCode,
        factoryName: factoryRes.factoryName,
        cropID: data.cropID,
        productCode: cropRes.productCode,
        productName: cropRes.productName,
        orderDate: data.dateID,
        quantity: parseFloat(data.quantity),
        editStatus: 2, //Edit Price Add Special Order Screen
        realizedPrice: parseFloat(data.price),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.UpdateSpecialOrder(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/AddSpecialOrder');
        }, 800);
      } else {
        toast.error(res.message);
      }
    }
  }
  const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;
  return (
    <>
      <LoadingComponent />
      <Page title="Add Special Order |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/dashboard/AddSpecialOrder'}
            btname="Back"
            pageName={pageProps.pageName}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    name="groupID"
                    //onChange={(e) => handleChangee(e)}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    //onChange={formik.handleChange}
                    name="operationEntityID"
                    onChange={(e) => handleChangee(e)}
                    //{...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    id="outlined-start-adornment"
                    size="small"
                    label="Order Date *"
                    type="Date"
                    value={formik.values.dateID}
                    onChange={formik.handleChange}
                    name="dateID"
                    {...getFieldProps('dateID')}
                    error={Boolean(touched.dateID && errors.dateID)}
                    helperText={touched.dateID && errors.dateID}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                    inputProps={{
                      min: new Date().toISOString().split('T')[0],
                    }}
                  >
                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Crop Category *"
                    value={formik.values.cropCategoryID}
                    //onChange={formik.handleChange}
                    name="cropCategoryID"
                    onChange={(e) => handleChangee(e)}
                    //{...getFieldProps('cropCategoryID')}
                    error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}
                    helperText={touched.cropCategoryID && errors.cropCategoryID}
                  >
                    <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                    {productcatogery.map((option) => (
                      option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                        {option.productCategoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  {pageProps.isEdit == false ?
                    <Autocomplete fullWidth
                      key={isFarmerClear}
                      id="cropID"
                      options={product}
                      getOptionLabel={(option) => option.productName != null ? option.productName.toString() : null}
                      onChange={(e, value) => handleSearchCrop(value, e)}
                      defaultValue={null}
                      renderInput={(params) =>
                        <TextField {...params}
                          variant="outlined"
                          name="cropID"
                          label="Crop *"
                          size="small"
                          fullWidth
                          value={formik.values.cropID}
                          getOptionDisabled={true}
                          helperText={touched.cropID && errors.cropID}
                          error={Boolean(touched.cropID && errors.cropID)}
                        />
                      }
                    /> :
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Crop *"
                      value={formik.values.cropID}
                      //onChange={formik.handleChange}
                      name="cropID"
                      onChange={(e) => handleChangee(e)}
                      //{...getFieldProps('cropID')}
                      error={Boolean(touched.cropID && errors.cropID)}
                      helperText={touched.cropID && errors.cropID}
                    >
                      <MenuItem key={0} value={0}> Select Crop</MenuItem>
                      {product.map((option) => (
                        <MenuItem key={option.productID} value={option.productID}>
                          {option.productName}
                        </MenuItem>
                      ))}
                    </TextField>}
                  <TextField
                    fullWidth
                    size="small"
                    label="Quantity *"
                    value={formik.values.quantity}
                    name="quantity"
                    //onChange={formik.handleChange}
                    onChange={(e) => handleChangee(e)}
                    //{...getFieldProps('quantity')}
                    error={Boolean(touched.quantity && errors.quantity)}
                    helperText={touched.quantity && errors.quantity}
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Price *"
                    style={{ width: '375px' }}
                    value={formik.values.price}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name="price"
                    {...getFieldProps('price')}
                    error={Boolean(touched.price && errors.price)}
                    helperText={touched.price && errors.price}
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  />
                </Stack>
              </Stack>
              <br />
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <Button type="submit" color="secondary" variant="outlined">
                  {pageProps.submitButtonName}
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page>
    </>
  );
}
